import * as React from 'react';

import {CTABanner} from 'shells/cta-banner/cta-banner';
import {SmsIcon} from 'shells/icon/svg/sms-icon';

import styles from './banner.module.css';

type Props = {
    width: number;
};

export function TextAutomationCtaBanner(props: Props) {
    return (
        <div style={{width: props.width}} className={styles['banner-container']}>
            <CTABanner
                icon={SmsIcon}
                title='Send automated texts to leads with SMS'
                text='Schedule SMS messages to send automatically when a lead is created, or when leads reach a certain stage.'
                buttonText='Get started'
                maxWidth={null}
                href='/inbox/settings/sms'
                newTab={true}
            />
        </div>
    );
}
